import React from 'react';
import PropTypes from 'prop-types';

export function BuyNowCartIcon({
    width = 24,
    height = 24,
    fill = 'currentColor',
    className,
    idSuffix = '',
    showBadge = false,
    ...rest
}) {
    const clipId = `cartIconClip${idSuffix}`;
    // long path - keep on single line to avoid modifying SVG path data
    // eslint-disable-next-line max-len
    const pathD = 'M15.55 13C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13H15.55ZM6.16 6H18.31L15.55 11H8.53L6.16 6ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z';

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            color='inherit'
            aria-hidden={rest['aria-label'] ? 'false' : 'true'}
            {...rest}
        >
            <g clipPath={`url(#${clipId})`}>
                <path d={pathD} fill={fill} />
                {showBadge
                    && (
                        <circle
                            className="cart-badge"
                            cx="19"
                            cy="5"
                            r="5"
                            fill="currentColor"
                            strokeWidth="2"
                        />
                    )}
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default BuyNowCartIcon;

BuyNowCartIcon.propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fill: PropTypes.string,
    className: PropTypes.string,
    idSuffix: PropTypes.string,
    showBadge: PropTypes.bool
};

BuyNowCartIcon.defaultProps = {
    width: 24,
    height: 24,
    fill: 'currentColor',
    className: undefined,
    idSuffix: '',
    showBadge: false
};
